import { useDispatch, useSelector } from "react-redux";
import { API_OPTIONS } from "../utils/constants"; // Ensure this contains API key and other necessary options
import { addNowPlayingMovies } from "../utils/moviesSlice";
import { useEffect } from "react";

const useNowPlayingMovies = () => {
  // Use dispatch to send data to the Redux store
  const dispatch = useDispatch();
  
  // Get now playing movies from the Redux store
  const nowPlayingMovies = useSelector(
    (store) => store.movies.nowPlayingMovies
  );

  // Function to fetch now playing movies from the TMDB API
  const getNowPlayingMovies = async () => {
    try {
      const response = await fetch(
        'https://api.themoviedb.org/3/movie/now_playing?page=1', 
        API_OPTIONS
      );

      // Handle network errors
      if (!response.ok) {
        throw new Error(`Error fetching movies: ${response.statusText}`);
      }

      const json = await response.json();

      // Dispatch the data to the Redux store
      dispatch(addNowPlayingMovies(json.results));
    } catch (error) {
      console.error('Failed to fetch now playing movies:', error);
    }
  };

  // Fetch data on component mount or when the data is not present
  useEffect(() => {
    if (!nowPlayingMovies) {
      getNowPlayingMovies();
    }
  }, [nowPlayingMovies]); // Add nowPlayingMovies as a dependency

  return nowPlayingMovies;
};

export default useNowPlayingMovies;
